import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import "../../styles/dashboard.css";
import api from "../../api.js";

const AddUser = () => {
  const [form, setForm] = useState({
    username: "",
    email: "",
    password: "",
    role: "subscriber",
    field_ids: [],
  });
  const [fields, setFields] = useState([]);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const token = Cookies.get("access_token");

  useEffect(() => {
    api.get("/field/myfields/", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => setFields(res.data))
    .catch((err) => console.error("Error loading fields", err));
  }, []);

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleFieldToggle = (fieldId) => {
    setForm((prev) => {
      const alreadySelected = prev.field_ids.includes(fieldId);
      return {
        ...prev,
        field_ids: alreadySelected
          ? prev.field_ids.filter((id) => id !== fieldId)
          : [...prev.field_ids, fieldId],
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    api.post("/register/", form, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(() => {
      setMessage("کاربر با موفقیت اضافه شد.");
      setForm({
        username: "",
        email: "",
        password: "",
        role: "subscriber",
        field_ids: [],
      });
    })
    .catch((err) => {
      console.error(err);
      setError("خطا در ثبت کاربر.");
    });
  };

  return (
    <div className="add-container">
      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>نام کاربری</label>
          <input type="text" className="form-control" name="username" value={form.username} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label>ایمیل</label>
          <input type="email" className="form-control" name="email" value={form.email} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label>رمز عبور</label>
          <input type="password" className="form-control" name="password" value={form.password} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label>نقش</label>
          <select name="role" className="form-select" value={form.role} onChange={handleChange}>
            <option value="manager">مدیر</option>
            <option value="author">نویسنده</option>
            <option value="contributer">همکار</option>
            <option value="subscriber">مشترک</option>
          </select>
        </div>
        <div className="mb-3">
          <label>دسترسی به حوزه‌ها</label>
          <div className="d-flex flex-wrap">
            {fields.map((field) => (
              <div key={field.id} className="form-check me-3 mb-2">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`field-${field.id}`}
                  checked={form.field_ids.includes(field.id)}
                  onChange={() => handleFieldToggle(field.id)}
                />
                <label className="form-check-label" htmlFor={`field-${field.id}`}>
                  {field.title}
                </label>
              </div>
            ))}
          </div>
        </div>
        <button type="submit" className="mt-4 btn btn-primary">ایجاد کاربر</button>
      </form>
    </div>
  );
};

export default AddUser;
